import shell from './shell'
import { mapTemplateToReducer } from './common'

export const analytics = {
  init(state, initialLoad, pathnameChange) {
    const { page } = state
    const mergedAnalytics = analytics.merge(state, page.analytics, page.template)

    if(initialLoad) {
      shell.track.init(mergedAnalytics)
    }else if(pathnameChange) {
      shell.track.page({ analytics: mergedAnalytics })
    }
    history.state.ads = page.ads
    history.state.analytics = page.analytics
    // TODO: update app state again? should we trigger another action?
  },
  merge(state = {}, data = {}, template) {
    const reducerName = mapTemplateToReducer(template)
    const reducer = state[ reducerName ] || {}
    const processedAnalytics = reducer.analytics || {}

    Object.keys(processedAnalytics).map(type => {
      const source = processedAnalytics[type] || {}
      Object.keys(source).map(prop => {
        if(processedAnalytics[type] && data[type]) {
          data[type][prop] = processedAnalytics[type][prop]
        }
      })
    })

    return data
  }
}

export default analytics



/** WEBPACK FOOTER **
 ** ../app/lib/utils/analytics.js
 **/